<template>

    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="ProductTypeList">

        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter :title="$t('Brands.Name')" :Filter="productTypeName" :getList="ProductTypeList"
                @cancel="productTypeName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="productTypeName" id="productTypeName" variant="outlined" maxlength="33"
                        hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('Brands.Category')" :Filter="productTypeCategory" :getList="ProductTypeList"
                @cancel="productTypeCategory = null" :index="index">
                <template v-slot:input>
                    <v-autocomplete v-model="productTypeCategory" id="productTypeCategory" variant="outlined"
                        hide-details :items="productTypeCategories" item-title="name" item-value="value"
                        :return-object="false" clearable persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('ProductType.Category') })"
                        class="rounded-xl input-field">
                        <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :value="item.value">
                                <v-list-item-title class="category-item">{{ item.name }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </template>
            </ColumnFilter>
        </template>


        <template v-slot:[SlotsFilters.Filter2]>
            <ColumnFilter :title="$t('Brands.Created')" :Filter="FieldCreatedDate" :getList="ProductTypeList"
                @cancel="FieldCreatedDate = null">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="FieldCreatedDate" :min-date="new Date('2000-01-01')" :max-date="new Date()"
                            :model-value="FieldCreatedDate" @update:model-value="handleDateRangeCreationDate" />
                    </span>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.name }} </template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ getCategoryName(item.typeCategory) }} </template>
        <template v-slot:[SlotsItems.item2]="{ item }">{{ item.created.split('T')[0] }}
            {{ item.created.split('T')[1].split('.')[0] }}</template>
        <template v-slot:edit="{ item, index }">
            <ProductTypeActionMenu :Id="index" v-bind:idProductType="item.id" v-bind:getProductType="item"
                v-bind:getProductTypeListAfterDelete="ProductTypeList" />
        </template>
    </gridComponent>
</template>
<script>
import { getProductTypes } from '@/api/index';
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import DateField from '@/genericComponent/date-field.vue';
import ProductTypeActionMenu from '@/components/ProductType/ProductTypeActionMenu.vue';
//import BrandDialogFilter from '@/components/Brands/BrandDialogFilter.vue';
export default {
    components: { GridComponent, ColumnFilter, DateField, ProductTypeActionMenu },
    props: {
        showFilterDialog: Boolean,

    },
    mounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.ProductTypeList();
        });
        this.dialogFilterclientsRef = this.$refs.dialogFilterclients;
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            productTypeCategory: null,
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            search: null,
            filterMenuitems: [1, 3, 4],
            productTypeName: null,
            FieldCategoryId: [],
            FieldCreatedDateFrom: null,
            FieldCreatedDateTo: null,
            FieldSupplierId: null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            MySupplier: null,
            item: null,
            suppliers: [],
            categories: [],

        }
    },
    methods: {
        loadList() {
            this.ProductTypeList(1);
        },
        handleNullableFilters() {
            this.productTypeName = null;
            this.productTypeCategory = null;
            this.Description = null;
            this.FieldAddress = null;
            this.FieldCompanyName = null;
            this.FieldStatus = null;
            this.FieldCreatedDate = null;
            this.$refs.dialogFilterclients.cleardialogfilter();
            this.ProductTypeList(1);
        },
        handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.FieldCreatedDateFrom = value[0];
                this.FieldCreatedDateTo = value[1];
            } else {
                this.FieldCreatedDateFrom = null;
                this.FieldCreatedDateTo = null;
            }
        },
        removeClient(selectedItem) {
            this.FieldSupplier.filter(i => i != selectedItem);
        },
        getCategoryName(value) {
            switch (value) {
                case 0:
                    return this.$t('ProductType.Categories.Standard');
                case 1:
                    return this.$t('ProductType.Categories.Perishable');
                case 2:
                    return this.$t('ProductType.Categories.Fragile');
                case 3:
                    return this.$t('ProductType.Categories.Hazardous');
                case 4:
                    return this.$t('ProductType.Categories.Oversized');
                default:
                    return 'Unknown';
            }
        },
        ProductTypeList: function (page) {
            if (page) { this.page = page }
            getProductTypes(this.page, this.PageSize, this.productTypeName, this.productTypeCategory, this.FieldCreatedDate, this.SortedBy, this.SortingType, null).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
        productTypeCategories() {
            return [
                { name: this.$t('ProductType.Categories.Standard'), value: 0 },
                { name: this.$t('ProductType.Categories.Perishable'), value: 1 },
                { name: this.$t('ProductType.Categories.Fragile'), value: 2 },
                { name: this.$t('ProductType.Categories.Hazardous'), value: 3 },
                { name: this.$t('ProductType.Categories.Oversized'), value: 4 }
            ];
        },
        headers() {
            const headers = [
                this.$t('ProductType.Name'),
                this.$t('ProductType.Category'),
                this.$t('ProductType.Created')

            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['50%', '20', '30%'];
            return headers;
        },

    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
